import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-110343ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c75","margin-right":"5px"} }, "*", -1))
const _hoisted_2 = { style: {"width":"20% !important","text-align":"left","margin-bottom":"15px"} }
const _hoisted_3 = { style: {"width":"15% !important","margin-bottom":"15px","overflow":"hidden"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c75","margin-right":"5px"} }, "*", -1))
const _hoisted_5 = { style: {"width":"20% !important","text-align":"left","margin-bottom":"15px"} }
const _hoisted_6 = { style: {"width":"15% !important","margin-bottom":"15px","overflow":"hidden"} }
const _hoisted_7 = { style: {"width":"20% !important","text-align":"left","margin-bottom":"15px"} }
const _hoisted_8 = { style: {"width":"15% !important","margin-bottom":"15px","overflow":"hidden"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c75","margin-right":"5px"} }, "*", -1))
const _hoisted_10 = { style: {"width":"5% !important","text-align":"left","margin-bottom":"15px"} }
const _hoisted_11 = { style: {"width":"15% !important","text-align":"left","margin-bottom":"15px"} }
const _hoisted_12 = { style: {"width":"15% !important","margin-bottom":"15px","overflow":"hidden"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_miezz_hscode = _resolveComponent("miezz-hscode")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_component_miezz_form, {
      ref: "ruleForm",
      modelValue: _ctx.form,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form) = $event)),
      fix: true,
      key: _ctx.random,
      class: "form"
    }, {
      "form-item": _withCtx(({ item }) => [
        (item.Prop == 'Code')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              prop: item.Prop,
              label: item.Label
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_input, {
                  trim: false,
                  modelValue: _ctx.form.Data.Code,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Data.Code) = $event)),
                  onHandleBlur: _ctx.onChangeCode,
                  placeholder: '请填写'
                }, null, 8, ["modelValue", "onHandleBlur"])
              ]),
              _: 2
            }, 1032, ["prop", "label"]))
          : _createCommentVNode("", true),
        (item.Prop == 'NameZh')
          ? (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
              label: _withCtx(() => [
                _hoisted_1,
                _createElementVNode("span", null, _toDisplayString(item.Label), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, [
                  _createVNode(_component_el_form_item, {
                    prop: item.Prop,
                    style: {"padding":"0px","margin":"0px","width":"100% !important"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_miezz_input, {
                        onHandleBlur: _ctx.onChangeNameZh,
                        modelValue: _ctx.form.Data.NameZh,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Data.NameZh) = $event)),
                        placeholder: '请填写',
                        style: {"width":"99% !important"}
                      }, null, 8, ["onHandleBlur", "modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["prop"])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Data.ZhAliass, (p, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    style: {"width":"20% !important","margin-bottom":"15px"},
                    key: index
                  }, [
                    _createVNode(_component_el_form_item, {
                      style: {"padding":"0px","margin":"0px","width":"100% !important"},
                      class: "inputAliasName",
                      prop: `ZhAliass[${index}].Name`,
                      rules: _ctx.form.Rules.ZhAliass_Name
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          onHandleBlur: ($event: any) => (_ctx.onChangeZhAlias(index)),
                          class: "inputDelete",
                          modelValue: p.Name,
                          "onUpdate:modelValue": ($event: any) => ((p.Name) = $event),
                          placeholder: '请填写',
                          style: _normalizeStyle((index%5==3 || index%5==8)?'width:100% !important;':'width:99% !important;')
                        }, {
                          suffix: _withCtx(() => [
                            _createVNode(_component_el_icon, {
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.onDeleteZh(index))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Close)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1032, ["onHandleBlur", "modelValue", "onUpdate:modelValue", "style"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"])
                  ]))
                }), 128)),
                _createElementVNode("span", _hoisted_3, [
                  _createElementVNode("span", {
                    style: {"cursor":"pointer"},
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onAddZh()))
                  }, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" 中文别名")
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        (item.Prop == 'NameEn')
          ? (_openBlock(), _createBlock(_component_el_form_item, { key: 2 }, {
              label: _withCtx(() => [
                _hoisted_4,
                _createElementVNode("span", null, _toDisplayString(item.Label), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_component_el_form_item, {
                    prop: item.Prop,
                    style: {"padding":"0px","margin":"0px","width":"100% !important"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_miezz_input, {
                        onHandleBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onChangeNameEn())),
                        trim: false,
                        modelValue: _ctx.form.Data.NameEn,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.Data.NameEn) = $event)),
                        placeholder: '请填写',
                        style: {"width":"99% !important"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["prop"])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Data.EnAliass, (p, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    style: {"width":"20% !important","margin-bottom":"15px"},
                    key: index
                  }, [
                    _createVNode(_component_el_form_item, {
                      style: {"padding":"0px","margin":"0px","width":"100% !important"},
                      prop: `EnAliass[${index}].Name`,
                      rules: _ctx.form.Rules.EnAliass_Name
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          trim: false,
                          onHandleBlur: ($event: any) => (_ctx.onChangeEn(index)),
                          class: "inputDelete",
                          modelValue: p.Name,
                          "onUpdate:modelValue": ($event: any) => ((p.Name) = $event),
                          placeholder: '请填写',
                          style: _normalizeStyle((index%5==3 || index%5==8)?'width:100% !important;':'width:99% !important;')
                        }, {
                          suffix: _withCtx(() => [
                            _createVNode(_component_el_icon, {
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.onDeleteEn(index))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Close)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1032, ["onHandleBlur", "modelValue", "onUpdate:modelValue", "style"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"])
                  ]))
                }), 128)),
                _createElementVNode("span", _hoisted_6, [
                  _createElementVNode("span", {
                    style: {"cursor":"pointer"},
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onAddEn()))
                  }, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" 英文别名")
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        (item.Prop == 'NameLatin')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              label: item.Label
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_el_form_item, {
                    prop: item.Prop,
                    style: {"padding":"0px","margin":"0px","width":"100% !important"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_miezz_input, {
                        onHandleBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onChangeNameLatin())),
                        trim: false,
                        modelValue: _ctx.form.Data.NameLatin,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.Data.NameLatin) = $event)),
                        placeholder: '请填写',
                        style: {"width":"99% !important"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["prop"])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Data.LatinAliass, (p, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    style: {"width":"20% !important","margin-bottom":"15px"},
                    key: index
                  }, [
                    _createVNode(_component_el_form_item, {
                      style: {"padding":"0px","margin":"0px","width":"100% !important"},
                      prop: `LatinAliass[${index}].Name`,
                      rules: _ctx.form.Rules.LatinAliass_Name
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          onHandleBlur: ($event: any) => (_ctx.onChangeLatin(index)),
                          trim: false,
                          class: "inputDelete",
                          modelValue: p.Name,
                          "onUpdate:modelValue": ($event: any) => ((p.Name) = $event),
                          placeholder: '请填写',
                          style: _normalizeStyle((index%5==3 || index%5==8)?'width:100% !important;':'width:99% !important;')
                        }, {
                          suffix: _withCtx(() => [
                            _createVNode(_component_el_icon, {
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.onDeleteLatin(index))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Close)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1032, ["onHandleBlur", "modelValue", "onUpdate:modelValue", "style"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"])
                  ]))
                }), 128)),
                _createElementVNode("span", _hoisted_8, [
                  _createElementVNode("span", {
                    style: {"cursor":"pointer"},
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onAddLatin()))
                  }, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" 拉丁别名")
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["label"]))
          : _createCommentVNode("", true),
        (item.Prop == 'HsCode')
          ? (_openBlock(), _createBlock(_component_el_form_item, { key: 4 }, {
              label: _withCtx(() => [
                _hoisted_9,
                _createElementVNode("span", null, _toDisplayString(item.Label), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_el_form_item, { style: {"padding":"0px","margin":"0px","width":"100% !important"} }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 中国 ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_el_form_item, {
                    prop: item.Prop,
                    style: {"padding":"0px","margin":"0px","width":"100% !important"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_miezz_input, {
                        onHandleFocus: _ctx.onHsCode,
                        modelValue: _ctx.form.Data.HsCode,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.Data.HsCode) = $event)),
                        placeholder: '请填写',
                        style: {"width":"99% !important"}
                      }, null, 8, ["onHandleFocus", "modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["prop"])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Data.CustomsCodes, (p, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    style: {"width":"20% !important","margin-bottom":"15px"},
                    key: index
                  }, [
                    _createVNode(_component_el_form_item, {
                      prop: `CustomsCodes[${index}].HsCode`,
                      rules: _ctx.form.Rules.CustomsCodes_HsCode,
                      style: _normalizeStyle([{"padding":"0px","margin":"0px","width":"99% !important"}, (index%5==3)?'float:right;':'float:left;'])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: p.HsCode,
                          "onUpdate:modelValue": ($event: any) => ((p.HsCode) = $event),
                          style: {"width":"100% !important"},
                          placeholder: p.CountryId?'请填写':'请先选择国家',
                          disabled: p.CountryId?false:true,
                          class: "inputDelete",
                          onBlur: ($event: any) => (_ctx.onChangeCustomsCodes_HsCode(index))
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              clearable: "",
                              filterable: "",
                              modelValue: p.CountryId,
                              "onUpdate:modelValue": ($event: any) => ((p.CountryId) = $event),
                              placeholder: "请选择国家",
                              style: {"width":"140px !important","background-color":"#D9ECFF"},
                              onChange: ($event: any) => (_ctx.onChangeCountry(index, p.CountryId))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countrys, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.Value,
                                    label: item.Label,
                                    value: item.Value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                          ]),
                          suffix: _withCtx(() => [
                            _createVNode(_component_el_icon, {
                              style: {"cursor":"pointer","font-size":"12px"},
                              onClick: ($event: any) => (_ctx.onDeleteHsCode(index))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Close)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled", "onBlur"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules", "style"])
                  ]))
                }), 128)),
                _createElementVNode("span", _hoisted_12, [
                  _createElementVNode("span", {
                    style: {"cursor":"pointer"},
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onAddHsCode()))
                  }, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" 海关编码 ")
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        (item.Prop == 'ChargeUnithZh')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 5,
              prop: item.Prop,
              label: item.Label
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_select, {
                  modelValue: _ctx.form.Data.ChargeUnithZh,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.Data.ChargeUnithZh) = $event)),
                  onHandleChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onChangeChargeUnitZh())),
                  valueKey: "Label",
                  labelKey: "Label",
                  options: _ctx.chargeUnits,
                  placeholder: '请选择'
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 2
            }, 1032, ["prop", "label"]))
          : _createCommentVNode("", true),
        (item.Prop == 'ChargeUnithEn')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 6,
              label: item.Label
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_input, {
                  modelValue: _ctx.form.Data.ChargeUnithEn,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.Data.ChargeUnithEn) = $event)),
                  onHandleBlur: _ctx.onChargeUnitEn,
                  placeholder: '请填写'
                }, null, 8, ["modelValue", "onHandleBlur"])
              ]),
              _: 2
            }, 1032, ["label"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])),
    _createVNode(_component_miezz_button_bar, {
      modelValue: _ctx.bottomButtons,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.bottomButtons) = $event)),
      onHandleClick: _ctx.handleClick
    }, null, 8, ["modelValue", "onHandleClick"]),
    _createVNode(_component_miezz_hscode, {
      ref: "HsCode",
      onOnSelectHsCode: _ctx.onSelectHsCode
    }, null, 8, ["onOnSelectHsCode"])
  ], 64))
}